export const indexToMatrixCoordinates = <T>(matrix: T[][], index: number) => {
    const length = getMatrixLength(matrix);
    const rowCount = matrix.length;
    const colCount = matrix.length ? matrix[0].length : 0;

    const clampedIndex = index % length;
    const row = Math.floor(clampedIndex / colCount);
    const col = clampedIndex % colCount;

    return { row, col };
};
export const getMatrixLength = <T>(matrix: T[][])=>{
    const length = matrix.length ? matrix[0].length * matrix.length : 0;
    return length;
};
export const shiftMatrix = <T>(matrix: T[][], offset: number): T[][] => {
    if (!offset) return matrix;
    const itemCount = matrix.length ? matrix[0].length * matrix.length : 0;
    if ((offset % itemCount) === 0)
        return matrix;

    const clampedOffset = ((offset % itemCount) + itemCount) % itemCount;

    const shiftedMatrix: T[][] = [];
    matrix.forEach(row => {
        shiftedMatrix.push(Array(row.length).fill(0))
    });
    for (let index = 0; index < getMatrixLength(matrix); index++) {
        const { row, col } = indexToMatrixCoordinates(matrix, index);

        const shiftedIndex = index + clampedOffset;
        const { row: shiftedRow, col: shiftedCol } = indexToMatrixCoordinates(matrix, shiftedIndex);

        shiftedMatrix[shiftedRow][shiftedCol] = matrix[row][col];
    }
    return shiftedMatrix;
};